import { render, staticRenderFns } from "./Top10UmsatzerloeseBereiche.vue?vue&type=template&id=73f8a6b8&"
import script from "./Top10UmsatzerloeseBereiche.vue?vue&type=script&lang=ts&"
export * from "./Top10UmsatzerloeseBereiche.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports